export enum FloorplanGridStyle {
  Solid = 'solid',
  Dotted = 'dotted',
  None = 'none',
}
